import vars from '../helpers';
import video from './video';

const $popup = vars.$document.find('.js-popup');
const $overlay = vars.$document.find('.js-popup-overlay');
const $popupWindow = vars.$document.find('.js-popup-window');
const $buttonOpen = vars.$document.find('.js-video-popup-open');
const $buttonClose = vars.$document.find('.js-popup-close');

let isPopupOpen = false;

const videoTemplate = (id) => {
	return (
		`<video class="video-js js-popup-video vjs-default-skin is-hidden"
			playsinline
			data-video="${id}"
			data-name="${id}"
			data-poster="/videos/${id}/cover.jpg"
			data-src="/videos/${id}/${id}.m3u8">
		</video>`);
};

const openPopup = (id) => {
	const tl = gsap.timeline();

	tl.from($popup, {
		onStart() {
			if (!$(`.js-popup-video[data-video="${id}"]`).length) {
				$popupWindow.append(videoTemplate(id));
			}

			$popup.removeClass('is-hidden');
			$popupWindow.data('popup', id).attr('data-popup', id);
			vars.$html.addClass('is-video-popup-open');
			vars.$document.find(`.js-popup-video[data-video="${id}"]`).removeClass('is-hidden');
			video.init(id);
		},
		onComplete() {
			isPopupOpen = true;
		},
		autoAlpha: 0,
		duration: 0.5,
		clearProps: 'all',
	});
};

const closePopup = () => {
	if (!isPopupOpen) {
		return;
	}

	const id = $popupWindow.data('popup');
	const tl = gsap.timeline();

	tl.to($popup, {
		onStart() {
			vars.$html.trigger('popup-video-paused', id);
		},
		onComplete() {
			$popup.addClass('is-hidden');
			$popupWindow.data('popup', false).attr('data-popup', false);
			vars.$html.removeClass('is-video-popup-open');

			vars.$document.find(`.js-popup-video[data-video="${id}"]`).addClass('is-hidden');

			isPopupOpen = false;
		},
		autoAlpha: 0,
		duration: 1,
		clearProps: 'all',
	});
};

const init = () => {
	$buttonOpen.on('click', (e) => {
		openPopup($(e.currentTarget).data('video'));
		vars.$html.trigger('video-popup-open', $(e.currentTarget).data('video-name'));
	});

	$buttonClose.on('click', () => {
		closePopup();
	});

	$overlay.on('click', () => {
		closePopup();
	});

	vars.$document.on('keydown', (e) => {
		if (e.keyCode === 27) {
			closePopup();
		}
	});
};

const destroy = () => {
	closePopup();
};

export default {
	init,
	destroy,
};
